/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateOrUpdateTaskItemAreaDtoTaskTypeData } from './CreateOrUpdateTaskItemAreaDtoTaskTypeData';
import {
    CreateOrUpdateTaskItemAreaDtoTaskTypeDataFromJSON,
    CreateOrUpdateTaskItemAreaDtoTaskTypeDataFromJSONTyped,
    CreateOrUpdateTaskItemAreaDtoTaskTypeDataToJSON,
} from './CreateOrUpdateTaskItemAreaDtoTaskTypeData';
import type { CreateEvaluationParameterScopeDto } from './CreateEvaluationParameterScopeDto';
import {
    CreateEvaluationParameterScopeDtoFromJSON,
    CreateEvaluationParameterScopeDtoFromJSONTyped,
    CreateEvaluationParameterScopeDtoToJSON,
} from './CreateEvaluationParameterScopeDto';
import type { CreateOrUpdateTaskItemAreaDtoCombinationTable } from './CreateOrUpdateTaskItemAreaDtoCombinationTable';
import {
    CreateOrUpdateTaskItemAreaDtoCombinationTableFromJSON,
    CreateOrUpdateTaskItemAreaDtoCombinationTableFromJSONTyped,
    CreateOrUpdateTaskItemAreaDtoCombinationTableToJSON,
} from './CreateOrUpdateTaskItemAreaDtoCombinationTable';
import type { CreateOrUpdateTaskItemAreaDtoMedicalSystemSetup } from './CreateOrUpdateTaskItemAreaDtoMedicalSystemSetup';
import {
    CreateOrUpdateTaskItemAreaDtoMedicalSystemSetupFromJSON,
    CreateOrUpdateTaskItemAreaDtoMedicalSystemSetupFromJSONTyped,
    CreateOrUpdateTaskItemAreaDtoMedicalSystemSetupToJSON,
} from './CreateOrUpdateTaskItemAreaDtoMedicalSystemSetup';
import type { CreateTaskItemQaEquipmentSetupDto } from './CreateTaskItemQaEquipmentSetupDto';
import {
    CreateTaskItemQaEquipmentSetupDtoFromJSON,
    CreateTaskItemQaEquipmentSetupDtoFromJSONTyped,
    CreateTaskItemQaEquipmentSetupDtoToJSON,
} from './CreateTaskItemQaEquipmentSetupDto';
import type { CreateOrUpdateTaskItemAreaDtoInstruction } from './CreateOrUpdateTaskItemAreaDtoInstruction';
import {
    CreateOrUpdateTaskItemAreaDtoInstructionFromJSON,
    CreateOrUpdateTaskItemAreaDtoInstructionFromJSONTyped,
    CreateOrUpdateTaskItemAreaDtoInstructionToJSON,
} from './CreateOrUpdateTaskItemAreaDtoInstruction';

/**
 * 
 * @export
 * @interface CreateOrUpdateTaskItemAreaDto
 */
export interface CreateOrUpdateTaskItemAreaDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateTaskItemAreaDto
     */
    id: string;
    /**
     * 
     * @type {CreateOrUpdateTaskItemAreaDtoMedicalSystemSetup}
     * @memberof CreateOrUpdateTaskItemAreaDto
     */
    medicalSystemSetup?: CreateOrUpdateTaskItemAreaDtoMedicalSystemSetup | null;
    /**
     * 
     * @type {Array<CreateTaskItemQaEquipmentSetupDto>}
     * @memberof CreateOrUpdateTaskItemAreaDto
     */
    qaEquipmentSetups?: Array<CreateTaskItemQaEquipmentSetupDto> | null;
    /**
     * 
     * @type {CreateOrUpdateTaskItemAreaDtoInstruction}
     * @memberof CreateOrUpdateTaskItemAreaDto
     */
    instruction?: CreateOrUpdateTaskItemAreaDtoInstruction | null;
    /**
     * 
     * @type {CreateOrUpdateTaskItemAreaDtoTaskTypeData}
     * @memberof CreateOrUpdateTaskItemAreaDto
     */
    taskTypeData?: CreateOrUpdateTaskItemAreaDtoTaskTypeData | null;
    /**
     * 
     * @type {CreateOrUpdateTaskItemAreaDtoCombinationTable}
     * @memberof CreateOrUpdateTaskItemAreaDto
     */
    combinationTable?: CreateOrUpdateTaskItemAreaDtoCombinationTable | null;
    /**
     * 
     * @type {Array<CreateEvaluationParameterScopeDto>}
     * @memberof CreateOrUpdateTaskItemAreaDto
     */
    evaluationScopes?: Array<CreateEvaluationParameterScopeDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateTaskItemAreaDto
     */
    $type?: CreateOrUpdateTaskItemAreaDtoTypeEnum;
}


/**
 * @export
 */
export const CreateOrUpdateTaskItemAreaDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoCreateOrUpdateTaskItemAreaDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.CreateOrUpdateTaskItemAreaDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateOrUpdateTaskItemAreaDtoTypeEnum = typeof CreateOrUpdateTaskItemAreaDtoTypeEnum[keyof typeof CreateOrUpdateTaskItemAreaDtoTypeEnum];



/**
 * Check if a given object implements the CreateOrUpdateTaskItemAreaDto interface.
 */
export function instanceOfCreateOrUpdateTaskItemAreaDto(value?: unknown): value is CreateOrUpdateTaskItemAreaDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateOrUpdateTaskItemAreaDtoTypeEnum)[0];
}

export function CreateOrUpdateTaskItemAreaDtoFromJSON(json: any): CreateOrUpdateTaskItemAreaDto {
    return CreateOrUpdateTaskItemAreaDtoFromJSONTyped(json, false);
}

export function CreateOrUpdateTaskItemAreaDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateTaskItemAreaDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'medicalSystemSetup': json['medicalSystemSetup'] == null ? undefined : CreateOrUpdateTaskItemAreaDtoMedicalSystemSetupFromJSON(json['medicalSystemSetup']),
        'qaEquipmentSetups': json['qaEquipmentSetups'] == null ? undefined : ((json['qaEquipmentSetups'] as Array<any>).map(CreateTaskItemQaEquipmentSetupDtoFromJSON)),
        'instruction': json['instruction'] == null ? undefined : CreateOrUpdateTaskItemAreaDtoInstructionFromJSON(json['instruction']),
        'taskTypeData': json['taskTypeData'] == null ? undefined : CreateOrUpdateTaskItemAreaDtoTaskTypeDataFromJSON(json['taskTypeData']),
        'combinationTable': json['combinationTable'] == null ? undefined : CreateOrUpdateTaskItemAreaDtoCombinationTableFromJSON(json['combinationTable']),
        'evaluationScopes': json['evaluationScopes'] == null ? undefined : ((json['evaluationScopes'] as Array<any>).map(CreateEvaluationParameterScopeDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateOrUpdateTaskItemAreaDtoToJSON(value?: CreateOrUpdateTaskItemAreaDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'medicalSystemSetup': CreateOrUpdateTaskItemAreaDtoMedicalSystemSetupToJSON(value['medicalSystemSetup']),
        'qaEquipmentSetups': value['qaEquipmentSetups'] == null ? undefined : ((value['qaEquipmentSetups'] as Array<any>).map(CreateTaskItemQaEquipmentSetupDtoToJSON)),
        'instruction': CreateOrUpdateTaskItemAreaDtoInstructionToJSON(value['instruction']),
        'taskTypeData': CreateOrUpdateTaskItemAreaDtoTaskTypeDataToJSON(value['taskTypeData']),
        'combinationTable': CreateOrUpdateTaskItemAreaDtoCombinationTableToJSON(value['combinationTable']),
        'evaluationScopes': value['evaluationScopes'] == null ? undefined : ((value['evaluationScopes'] as Array<any>).map(CreateEvaluationParameterScopeDtoToJSON)),
        '$type': value['$type'],
    });
}

